import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VmePipesModule } from '../../../vme-pipes.module';
import { VmeCommonModule } from '../../../vme-common.module';
import { TimeSlot } from '../../../interfaces/travel-scheduler/time-window-response';

@Component({
  selector: 'schedule-options-time',
  standalone: true,
  imports: [CommonModule, VmeCommonModule, VmePipesModule],
  templateUrl: './schedule-options-time.component.html',
  styleUrls: ['./schedule-options-time.component.css'],
})
export class ScheduleOptionsTimeComponent implements OnInit {
  ngOnInit(): void {}
  @Input() availableTimeSlots: TimeSlot[] = [];

  @Output() timeSelected = new EventEmitter<TimeSlot>();

  @Input() selectedTime: Date = null;

  private selectedSlot: TimeSlot;

  onSelectTime(slot: TimeSlot) {
    if (slot == this.selectedSlot) {
      this.selectedTime = null;
      this.selectedSlot = null;
    } else {
      this.selectedTime = slot.startTime;
      this.selectedSlot = slot;
    }
    this.timeSelected.emit(this.selectedSlot);
  }

  constructor() {}

  addHours(date: Date, hours: number): Date {
    const copy = new Date(date);
    copy.setHours(copy.getHours() + hours);
    return copy;
  }
  protected isSameTime(d1: Date, d2: Date | null): boolean {
    return !!d1 && !!d2 && d1.getHours() === d2.getHours() && d1.getMinutes() === d2.getMinutes();
  }
}
